/**
 * Heuristic: if URL looks like a Wikifield wiki page, return "Wikifield: PageName", else return the URL.
 * Shared by EventsList, PeriodsList, and DetailDrawer.
 */
function linkDisplayLabel(url) {
  try {
    const u = new URL(url);
    const path = u.pathname || "";
    const wikiMatch = path.match(/\/wiki\/(.+)/);
    if (wikiMatch && (u.hostname.includes("wikifield") || u.hostname.includes("wiki."))) {
      return "Wikifield: " + decodeURIComponent(wikiMatch[1].replace(/\+/g, " "));
    }
  } catch (_) {}
  return url;
}

export default linkDisplayLabel;
